import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const deviceSKUConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default deviceSKUConfig;
